import React, { useId } from 'react'
import PropTypes from 'prop-types'

const GridLargeIcon = React.forwardRef(function GridLargeIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C3.80228 2 2 3.80228 2 6V18C2 20.1977 3.80228 22 6 22H18C20.1977 22 22 20.1977 22 18V6C22 3.80228 20.1977 2 18 2H6ZM0 6C0 2.69772 2.69772 0 6 0H18C21.3023 0 24 2.69772 24 6V18C24 21.3023 21.3023 24 18 24H6C2.69772 24 0 21.3023 0 18V6Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 1V23H11V1H13Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 13H1V11H23V13Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

GridLargeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

GridLargeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default GridLargeIcon
